import type { Observable } from 'rxjs';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * This function will wrap an existing Observable, and return an Observable with a mockValue when the experience
 * editor is active.
 *
 * @param observable The original Observable to be used when the experience-editor is inactive
 * @param mockValue The mockValue that will be returned as an Observable when the experience-editor is active
 */
export function mockForXp<T>(
  xpEditorActive: Observable<boolean>,
  observable: Observable<T>,
  mockValue: T
): Observable<T> {
  return combineLatest([xpEditorActive, observable]).pipe(
    map(([xpActive, value]) => (xpActive ? mockValue : value))
  );
}
